<template>
  <section class="section">
    <div class="container split">
      <div>
        <h1>Entreprises</h1>
        <p class="lead">
          Un accompagnement stratégique pour sécuriser votre activité, protéger vos dirigeants
          et garantir la continuité opérationnelle.
        </p>
        <ul class="list">
          <li>Responsabilité civile professionnelle et exploitation</li>
          <li>Multirisque professionnelle et protection des locaux</li>
          <li>Flotte automobile et mobilité des collaborateurs</li>
          <li>Santé collective, prévoyance et retraite</li>
          <li>Protection juridique et cyber-risques</li>
        </ul>
      </div>
      <div class="panel">
        <h2>Pour qui ?</h2>
        <p>TPE, PME, professions libérales et structures en croissance.</p>
        <h2>Notre valeur ajoutée</h2>
        <p>Audit complet, priorisation des risques et négociation des garanties.</p>
        <router-link class="button primary" to="/contact">Échanger sur votre entreprise</router-link>
      </div>
    </div>
  </section>
</template>
